import { eq } from "drizzle-orm";
import { branch, dining_table, type PowerSyncDrizzleDB } from "@comandero/powersync";
import { nowISO } from "../utils/date-helpers";
import { generateUUID } from "../utils/uuid";

export async function createBranchMutation(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  name: string,
  opts?: { address?: string; timezone?: string },
): Promise<string> {
  const id = generateUUID();
  const now = nowISO();
  await db.insert(branch).values({
    id,
    organization_id: organizationId,
    name: name.trim(),
    address: opts?.address ?? null,
    timezone: opts?.timezone ?? null,
    created_at: now,
    updated_at: now,
  });
  return id;
}

export type TableStatus = "free" | "occupied" | "bill_requested";

export async function createTableMutation(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  branchId: string,
  name: string,
  opts?: { seats?: number; sortOrder?: number },
): Promise<string> {
  const id = generateUUID();
  const now = nowISO();
  await db.insert(dining_table).values({
    id,
    organization_id: organizationId,
    branch_id: branchId,
    name: name.trim(),
    seats: opts?.seats ?? 2,
    status: "free",
    sort_order: opts?.sortOrder ?? 0,
    created_at: now,
    updated_at: now,
  });
  return id;
}

/**
 * Coloca (o re-coloca) una mesa en una celda del plano del salón.
 * `null` en ambas coordenadas = quitarla del plano (vuelve a auto-reparto).
 */
export async function setTablePositionMutation(
  db: PowerSyncDrizzleDB,
  tableId: string,
  posX: number | null,
  posY: number | null,
): Promise<void> {
  await db
    .update(dining_table)
    .set({
      pos_x: posX === null ? null : Math.trunc(posX),
      pos_y: posY === null ? null : Math.trunc(posY),
      updated_at: nowISO(),
    })
    .where(eq(dining_table.id, tableId));
}

export async function setTableStatusMutation(
  db: PowerSyncDrizzleDB,
  tableId: string,
  status: TableStatus,
): Promise<void> {
  await db
    .update(dining_table)
    .set({ status, updated_at: nowISO() })
    .where(eq(dining_table.id, tableId));
}
